// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAKFsf5eM_1iwerla87lc_94PeOxy09O7Y",
  authDomain: "shortsgenie-e6ab0.firebaseapp.com",
  projectId: "shortsgenie-e6ab0",
  storageBucket: "shortsgenie-e6ab0.appspot.com",
  messagingSenderId: "324446983567",
  appId: "1:324446983567:web:04e90c65c1d8e9955de7fa",
  measurementId: "G-XK4TKE6TC3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
// Initialize Firebase Auth provider
const provider = new GoogleAuthProvider();
  
// whenever a user interacts with the provider, we force them to select an account
provider.setCustomParameters({   
    prompt : "select_account "
});
const auth = getAuth(app);
export {auth};
export const signInWithGooglePopup = () => signInWithPopup(auth, provider);